import React, { Component, Fragment } from 'react';
import axios from 'axios';
import { Loader, Segment, Header, Button, Form, Icon, Message } from 'semantic-ui-react';
import moment from 'moment';

import { fetchAcademicYears, fetchAllAcademicYears, fetchCountries, fetchFaculties } from '../Lookups/util';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { toast, ToastContainer } from 'react-toastify';
import { FiltersOnStyle } from '../Professor/ProfessorInputGrades/css';
import ExternalStudentsTable from './ExternalStudentTable';

const OTHER_ACTIVITIES_VALUE = 'OTHER_ACTIVITIES';

export const filterStudents = (state) => {
    let filteredStudents = state.students;

    if (state.selectedAcademicYearId) {
        filteredStudents = filteredStudents.filter(student => student.academicYear.id === state.selectedAcademicYearId);
    }
    if (state.selectedFacultyId) {
        filteredStudents = filteredStudents.filter(student => {
            return state.studentOrganizationalUnits.some(
                unit => unit.externalStudent.id === student.id &&
                    unit.organizationalUnit.id === state.selectedFacultyId
            );
        });
    }
    if (state.selectedCourseId) {
        if (state.selectedCourseId === OTHER_ACTIVITIES_VALUE) {
            filteredStudents = filteredStudents.filter(student =>
                state.studentOUCourses.some(
                    unit => unit.externalStudentId === student.id &&
                        unit.isActivity === true &&
                        unit.courseStudyProgramId === null
                )
            );
        } else {
            filteredStudents = filteredStudents.filter(student =>
                state.studentOUCourses.some(
                    unit => unit.externalStudentId === student.id &&
                        unit.courseBasicId === state.selectedCourseId
                )
            );
        }
    }
    if (state.selectedCountryId) {
        filteredStudents = filteredStudents.filter(student => student.birthCountry.id === state.selectedCountryId);
    }

    return {
        filteredStudents,
        // @formatter:off
        excelData: [{
            columns: [
                { title: 'Ime', width: { wpx: 110 } },
                { title: 'Prezime', width: { wpx: 110 } },
                { title: 'Datum rođenja', width: { wpx: 110 } },
                { title: 'Država', width: { wpx: 200 } },
                { title: 'Spol', width: { wpx: 90 } },
                { title: 'Ciklus studija', width: { wpx: 200 } },
                { title: 'Polje obrazovanja', width: { wpx: 220 } },
                { title: 'Univerzitet', width: { wpx: 400 } },
                { title: 'Fakultet', width: { wpx: 400 } },
                { title: 'Odsjek', width: { wpx: 300 } },
                { title: 'Erasmus kod', width: { wpx: 110 } },
                { title: 'Adresa', width: { wpx: 220 } },
                { title: 'Država institucije', width: { wpx: 200 } },
                { title: 'Datum početka razmjene', width: { wpx: 170 } },
                { title: 'Datum završetka razmjene', width: { wpx: 170 } },
                { title: 'Akademska godina', width: { wpx: 130 } },
                { title: 'Tip razmjene', width: { wpx: 130 } },
                { title: 'Ime kontakt osobe', width: { wpx: 160 } },
                { title: 'Prezime kontakt osobe', width: { wpx: 160 } },
                { title: 'Email kontakt osobe', width: { wpx: 190 } },
                { title: 'Telefon kontakt osobe', width: { wpx: 140 } },
                { title: 'ESI - Evropski studentski identifikator', width: { wpx: 300 } },
                { title: 'Nivo poznavanja engleskog jezika', width: { wpx: 300 } },
                { title: 'Tip mobilnosti', width: { wpx: 200 } },
            ],
            data: filteredStudents.map(student => ([
                { value: student.firstName },
                { value: student.lastName },
                { value: student.dateOfBirth ? moment(student.dateOfBirth).format('D. M. YYYY.') : '' },
                { value: student.country ? student.country.name : '' },
                { value: student.gender ? student.gender.name : '' },
                { value: student.studyCycle ? student.studyCycle.name : '' },
                { value: student.fieldOfEducation ? student.fieldOfEducation.name + ' - ' + student.fieldOfEducation.code : '' },
                { value: student.sendingInstitutionName || '' },
                { value: student.sendingInstitutionFacultyName || '' },
                { value: student.sendingInstitutionDepartment || '' },
                { value: student.sendingInstitutionErasmusCode || '' },
                { value: student.sendingInstitutionAddress || '' },
                { value: student.sendingInstitutionCountry ? student.sendingInstitutionCountry.name : '' },
                { value: student.dateFrom ? moment(student.dateFrom).format('D. M. YYYY.') : '' },
                { value: student.dateTo ? moment(student.dateTo).format('D. M. YYYY.') : '' },
                { value: student.academicYear ? student.academicYear.name : '' },
                { value: student.mobilityProgram ? student.mobilityProgram.name : '' },
                { value: student.sendingContactPersonFirstName || '' },
                { value: student.sendingContactPersonLastName || '' },
                { value: student.sendingContactPersonEmail || '' },
                { value: student.sendingContactPersonPhone || '' },
                { value: student.europeanStudentIdentifier || '' },
                { value: student.englishLevelCompetence ? student.englishLevelCompetence.name : '' },
                { value: student.mobilityFormat ? student.mobilityFormat.name : '' }
            ]))
        }]
        // @formatter:on
    };
};

class ExternalStudentList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            students: [],
            filteredStudents: [],
            loading: true,
            studentOrganizationalUnits: [],
            studentOUCourses: [],
            academicYears: [],
            faculties: [],
            courses: [],
            countries: [],
            nonGradedWarnings: new Map(),

            selectedAcademicYearId: null,
            selectedFacultyId: null,
            selectedCourseId: null,
            selectedCountryId: null,
            searchText: '',
            activePage: 1,
            postsPerPage: 10,

            excelData: [],

            deletingRowId: null,
            saving: false,
        };

        this.fetchInitialData = this.fetchInitialData.bind(this);
        this.getResults = this.getResults.bind(this);
        this.handleSearchTextChange = this.handleSearchTextChange.bind(this);
        this.filterStudents = this.filterStudents.bind(this);
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
        this.handleConfirmClick = this.handleConfirmClick.bind(this);
        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.handlePaginationChange = this.handlePaginationChange.bind(this);

    }

    componentDidMount() {
        this.fetchInitialData();
    }

    fetchInitialData() {
        this.setState({ loading: true });

        const localStorageRole = localStorage.getItem('activeRole') || '';
        const isAdmin = localStorageRole === 'Administrator' || localStorageRole === 'AIDA';
        const isInternationalCooperationService = localStorageRole === 'Služba za međunarodnu saradnju';
        const isStudentService = localStorageRole.slice(0, 10) === 'Studentska';
        const isProfessor = localStorageRole.slice(0, 8) === 'Profesor';

        const requests = [
            axios.get('/external-student'), // TODO: fetch students by academic year
            fetchFaculties(),
            fetchAcademicYears(),
            fetchCountries(),
        ];

        if (isAdmin || isInternationalCooperationService) {
            requests.push(axios.get('/external-student-organization-unit'));
        }

        if (isProfessor) {
            requests.push(axios.get('/external-student-course/grading'));
        }

        Promise.all(requests)
            .then((responses) => {
                const externalStudentsResponse = responses[0];
                const facultiesResponse = responses[1];
                const academicYearsResponse = responses[2];
                const countriesResponse = responses[3];
                let studentOrganizationalUnitsResponse = { data: [] };
                let studentOUCoursesResponse = { data: [] };
                if (isAdmin || isInternationalCooperationService) {
                    studentOrganizationalUnitsResponse = responses[4];
                }
                if (isProfessor) {
                    studentOUCoursesResponse = responses[4];
                }

                const courseOptions = Array.from(
                    new Map(
                        studentOUCoursesResponse.data
                            .filter((item => !item.isActivity))
                            .map(item => [item.courseBasicId, {
                                key: item.courseBasicId,
                                text: item.courseName,
                                value: item.courseBasicId,
                            }])
                    ).values()
                );

                if (studentOUCoursesResponse.data.some(item => item.isActivity)) {
                    courseOptions.unshift({
                        key: OTHER_ACTIVITIES_VALUE,
                        text: <FormattedMessage id="externalStudent.otherActivityTypes"/>,
                        value: OTHER_ACTIVITIES_VALUE,
                    });
                }

                const nonGradedWarnings = new Map();
                studentOUCoursesResponse.data.forEach(item => {
                    if (item.markKey === 'nonp' || !item.markKey) {
                        if (!nonGradedWarnings.has(item.externalStudentId)) {
                            nonGradedWarnings.set(item.externalStudentId, []);
                        }

                        nonGradedWarnings
                            .get(item.externalStudentId)
                            .push(item.isActivity ? item.activityName : item.courseName);
                    }
                });

                const sortedStudents = externalStudentsResponse.data.sort((a, b) => {
                    const dateA = new Date(a.dateTo);
                    const dateB = new Date(b.dateTo);
                    return dateB - dateA; // Sort by dateTo ascending
                });
                this.setState({
                        students: sortedStudents,
                        filteredStudents: sortedStudents,
                        studentOrganizationalUnits: studentOrganizationalUnitsResponse.data,
                        studentOUCourses: studentOUCoursesResponse.data,
                        courses: courseOptions,
                        faculties: facultiesResponse.data,
                        academicYears: academicYearsResponse.data.sort((a, b) => b.startYear - a.startYear),
                        countries: countriesResponse.data,
                        loading: false,
                        selectedAcademicYearId: academicYearsResponse.data.length > 0 ? academicYearsResponse.data[0].id : null,
                        nonGradedWarnings,
                    }, () => {
                        this.filterStudents();
                    }
                );
            })
            .catch((error) => {
                // console.error('Greška prilikom dohvata podataka:', error);
                this.setState({ loading: false });
            });
    }

    getResults = (results) => {
        // console.log('Results:', results);
        // console.log('Search Text:', this.state.searchText);
        if (results.length === 0 && this.state.searchText.trim() === '') {
            this.filterStudents();
        } else {
            this.setState({
                filteredStudents: results,
                activePage: 1,
                currentPage: 1
            });
        }
    };

    handleSearchTextChange = (text) => {
        this.setState({ searchText: text });
    };

    filterStudents = () => {
        const {
            filteredStudents,
            excelData
        } = filterStudents(this.state);

        this.setState({
            filteredStudents,
            excelData,
            activePage: 1,
        });
    };

    handlePaginationChange = (e, { activePage }) => {
        this.setState({ activePage });
    };

    handleCancelClick = () => {
        this.setState({ deletingRowId: null });
    };

    handleDeleteClick = (studentId) => {
        this.setState({ deletingRowId: studentId });
    };

    handleConfirmClick = () => {
        this.setState({ saving: true });
        axios.delete(`/external-student/${this.state.deletingRowId}`)
            .then((response) => {
                toast(<FormattedMessage id="externalStudent.toast.studentSuccessfullyDeleted"/>);
                this.setState((prevState) => ({
                    students: prevState.students.filter(student => student.id !== prevState.deletingRowId),
                    deletingRowId: null,
                    saving: false,
                }), () => {
                    this.filterStudents();
                });
            })
            .catch((error) => {
                this.setState({ saving: false });
                toast(<FormattedMessage id="externalStudent.toast.saveError"/>);
            });
    };

    render() {
        const {
            students,
            filteredStudents,
            excelData,
            loading,
            academicYears,
            faculties,
            courses,
            countries,
            selectedAcademicYearId,
            selectedFacultyId,
            selectedCourseId,
            selectedCountryId,
            activePage,
            postsPerPage,
            deletingRowId,
            saving,
            nonGradedWarnings,
        } = this.state;

        // const filteredStudents = this.filterStudents();
        const localStorageRole = localStorage.getItem('activeRole') || '';
        const isAdmin = localStorageRole === 'Administrator' || localStorageRole === 'AIDA';
        const isInternationalCooperationService = localStorageRole === 'Služba za međunarodnu saradnju';
        const isStudentService = localStorageRole.slice(0, 10) === 'Studentska';
        const isProfessor = localStorageRole.slice(0, 8) === 'Profesor';
        const pageTitle = 'Dolazne mobilnosti';
        const segmentTitle = 'Studenti dolazne mobilnosti';
        const studentsDescription = 'U tabeli su prikazani svi studenti dolazne mobilnosti. Klikom na dugme "Profil studenta" se otvara stranica sa detaljnim informacijama o studentu, njegovoj razmjeni i ostalim relevantnim podacima.';

        return (
            <div>
                <h2>{pageTitle}</h2>
                <Segment.Group raised>
                    <Segment>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <Header as="h3" style={{ margin: 0 }}>
                                {segmentTitle}
                            </Header>
                            {(/*isAdmin || isInternationalCooperationService || */isStudentService) && (
                                <Button
                                    as={Link}
                                    to={{ pathname: '/dolazne-mobilnosti/kreiranje' }}
                                    primary
                                    color="green"
                                    disabled={loading}
                                    loading={loading}
                                    floated="right"
                                    icon
                                    labelPosition="right"
                                    size="small"
                                    style={FiltersOnStyle}
                                ><Icon className="add"/>
                                    <FormattedMessage id="externalStudent.addingExternalStudent"/>
                                </Button>)}
                        </div>
                    </Segment>
                    <Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Select
                                    search
                                    fluid
                                    label={<FormattedMessage id="externalStudent.academicYear"/>}
                                    placeholder={<FormattedMessage id="externalStudent.selectAcademicYear"/>}
                                    // clearable={true}
                                    options={academicYears.map(y => ({
                                        key: y.id,
                                        text: y.name,
                                        value: y.id
                                    }))}
                                        value={selectedAcademicYearId}
                                        onChange={(e, { value }) =>
                                        this.setState({ selectedAcademicYearId: value, activePage: 1 }, this.filterStudents)
                                    }
                                />
                                {(isAdmin || isInternationalCooperationService) && (
                                    <Form.Select
                                        search
                                        loading={loading}
                                        fluid
                                        label={<FormattedMessage id="externalStudent.faculty"/>}
                                        placeholder={<FormattedMessage id="externalStudent.selectFaculty"/>}
                                        clearable={true}
                                        options={faculties.map(f => ({
                                            key: f.id,
                                            text: f.name,
                                            value: f.id
                                        }))}
                                        value={selectedFacultyId}
                                        onChange={(e, { value }) =>
                                            this.setState({ selectedFacultyId: value, activePage: 1 }, this.filterStudents)
                                        }
                                    />)}
                                {(isProfessor) && (
                                    <Form.Select
                                        search
                                        loading={loading}
                                        fluid
                                        label={<FormattedMessage id="externalStudent.course"/>}
                                        placeholder={<FormattedMessage id="externalStudent.selectCourse"/>}
                                        clearable={true}
                                        options={courses}
                                        value={selectedCourseId}
                                        onChange={(e, { value }) =>
                                            this.setState({ selectedCourseId: value, activePage: 1 }, this.filterStudents)
                                        }
                                    />)}
                                <Form.Select
                                    search
                                    fluid
                                    label={<FormattedMessage id="externalStudent.country"/>}
                                    placeholder={<FormattedMessage id="externalStudent.selectCountry"/>}
                                    clearable={true}
                                    options={countries.map(c => ({
                                        key: c.id,
                                        text: c.name,
                                        value: c.id
                                    }))}
                                    value={selectedCountryId}
                                    onChange={(e, { value }) =>
                                        this.setState({ selectedCountryId: value, activePage: 1 }, this.filterStudents)
                                    }
                                />
                            </Form.Group>
                        </Form>
                    </Segment>
                    <Segment>
                        {loading ? (
                            <Loader active inline="centered"/>
                        ) : (
                            <Fragment>
                                <Message>{studentsDescription}</Message>
                                <ExternalStudentsTable
                                    students={students}
                                    filteredStudents={filteredStudents}
                                    excelData={excelData}
                                    activePage={activePage}
                                    postsPerPage={postsPerPage}
                                    handlePaginationChange={this.handlePaginationChange}

                                    getResults={this.getResults}
                                    handleSearchTextChange={this.handleSearchTextChange}

                                    deletingRowId={deletingRowId}
                                    saving={saving}

                                    handleDeleteClick={this.handleDeleteClick}
                                    handleConfirmClick={this.handleConfirmClick}
                                    handleCancelClick={this.handleCancelClick}

                                    isAdmin={isAdmin}
                                    isInternationalCooperationService={isInternationalCooperationService}
                                    isStudentService={isStudentService}

                                    nonGradedWarnings={nonGradedWarnings}
                                />
                            </Fragment>
                        )}
                    </Segment>
                    <ToastContainer position="top-right" hideProgressBar={true}/>
                </Segment.Group>
            </div>
        );
    }
}

export default ExternalStudentList;



// WEBPACK FOOTER //
// ./src/views/ExternalStudents/ExternalStudentList.js